import React from 'react';

function SalesOrdersStatus({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M8.998 15a1 1 0 1 0 .004 2 1 1 0 0 0-.004-2ZM6 7v1h1l1.8 3.795-.675 1.225A.967.967 0 0 0 8 13.5c0 .55.45 1 1 1h6v-1H9.21a.124.124 0 0 1-.125-.125l.015-.06.45-.815h3.725a.995.995 0 0 0 .875-.515l1.79-3.245A.501.501 0 0 0 15.5 8H8.105l-.47-1H6Zm7.998 8a1 1 0 1 0 .004 2 1 1 0 0 0-.004-2Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="m23 8.358-1.846.445C19.695 2.99 14.081-.288 8.61 1.478 3.14 3.245-.11 9.384 1.35 15.198c1.264 5.035 5.33 7.577 9.32 7.841 5.312.509 9.941-2.75 10.65-7.736l-2.644-.557c-.375 2.978-3.22 5.261-6.545 5.652-3.575.235-7.378-2.304-8.306-6-1.093-4.353 1.348-8.966 5.446-10.29 4.097-1.322 8.315 1.14 9.408 5.494l-1.88.956 4.51 2.75L23 8.358Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default SalesOrdersStatus;
